import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { Box, FormCardSection, Select } from '/src/components';
import { useUserStore } from '/src/context';
import { ClientDataForm, CountryId } from '/src/lib/types';

export const ClientCountry: React.FC<ClientCountryProps> = observer((props) => {
  const { formValues, updateFormValue, formErrors, id, disabled } = props;

  const userStore = useUserStore();
  const { t } = useTranslation();

  const isDisabled = disabled || (!userStore.isFuseAdmin && (!userStore.isAdminUser || !userStore.isClientUser));

  return (
    <FormCardSection id={id} title={t('client:programCountry')}>
      <Box margin={{ bottom: '1rem' }} gap="1rem">
        <Select
          name="country_id"
          label={t('client:country')}
          placeholder={t('client:countryPlaceholder')}
          value={Number.isNaN(formValues.country_id) ? undefined : formValues.country_id}
          setValue={(value) => updateFormValue('country_id', value)}
          options={[
            { label: t('client:unitedStates'), value: CountryId.USA },
            { label: t('client:canada'), value: CountryId.Canada },
          ]}
          error={formErrors['country_id']}
          required
          disabled={isDisabled}
        />
      </Box>
    </FormCardSection>
  );
});

export type ClientCountryProps = {
  formValues: ClientDataForm;
  updateFormValue: (key: string, value: unknown) => void;
  formErrors: Record<string, string>;
  id?: string;
  disabled?: boolean;
};
